import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { IPartnerRating } from '../../interfaces';
import { savePartnerRating } from './api';

export function useSavePartnerRating() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const saveRating = async (requests: IPartnerRating[]): Promise<boolean> => {
    setLoading(true);

    try {
      await savePartnerRating(requests);
      return true;
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, saveRating };
}
